import { useEffect, useState } from "react";
import { CUSTOM_EVENTS, MESSAGES } from "../../constants";
import { useDevice } from "../../hooks/useDevice";
import Modal from "../ui-atoms/Modal/Modal";
import LandingButton from "../ui-atoms/LandingButton/LandingButton";
import ParaTag from "../ui-atoms/TextStyles/ParaTag";

interface LoginErrorModalTypes {
  onClose?: () => void;
  onOpen?: () => void;
  forceHide?: boolean;
}

export const LoginErrorModal = ({
  onClose,
  onOpen,
  forceHide,
}: LoginErrorModalTypes) => {
  const device = useDevice();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    document.addEventListener(
      CUSTOM_EVENTS.LOGIN_ERROR_EVENT,
      onLoginErrorEventDispatched
    );
    return () => {
      document.removeEventListener(
        CUSTOM_EVENTS.LOGIN_ERROR_EVENT,
        onLoginErrorEventDispatched
      );
    };
  }, []);

  const onLoginErrorEventDispatched = (event: any) => {
    setShowModal(event?.detail?.showModal || "");
    if (event?.detail?.showModal && onOpen) {
      onOpen();
    }
  };

  return showModal && !forceHide ? (
    <Modal
      modalHeading={"Login Error"}
      onModalClose={() => {
        setShowModal(false);
        onClose && onClose();
      }}
      modalType={device === "lg" ? "centered" : "bottomSheet"}
    >
      <ParaTag
        fontSize={device === "lg" ? "md" : "sm"}
        lineHeight={device === "lg" ? "18px" : "20px"}
        margin="32px 0 16px 0"
      >
        {MESSAGES.LOGIN_ERROR}
      </ParaTag>
      <LandingButton
        customTitle="OK"
        onClick={() => {
          setShowModal(false);
          onClose && onClose();
        }}
        customWidth="100%"
      />
    </Modal>
  ) : null;
};

export default LoginErrorModal;
